var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('div',[_c('mini-statistic',{attrs:{"toggle_tingkat":_vm.toggle_tingkat}}),_c('chart-statistic',{attrs:{"toggle_tingkat":_vm.toggle_tingkat}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }